import { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal, Container } from 'react-bootstrap';
import ProgressBar from '@ramonak/react-progress-bar';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

import GREEN_CHECK from '../../images/green-checklist.png';
import RED_CROSS from '../../images/red-cross.png';
import CloseIcon from '../../images/close-button-search.png';
import GREEN_INFO_BUTTON from '../../images/info-button.png';
import GREY_INFO_BUTTON from '../../images/info-disable.png';
import InfoYellow from '../../images/danger-sign-yellow.png';
import RoundCloseButton from '../../images/round-close-button.png';

import { SELLING_COMMISSION_IMAGE } from "../../config";

const PointsCalculation = [
  {
    icon: GREEN_CHECK,
    description: 'Successful Transaction',
    point: '+0.2',
    reason: null,
  },
  {
    icon: RED_CROSS,
    description: 'Transaction Failed',
    point: '-1',
    reason:
      'Rejecting incoming order, shipping order that is not in accordance with the conditions, or confirming the order late.',
  },
  {
    icon: RED_CROSS,
    description: 'Transaction Not Passing Authentication',
    point: '-2',
    reason: 'Sending Fake Product',
  },
];

type Props = {
  dataAuth: any;
  sellerPoints: any;
  isOpen: boolean;
  onToggle: () => any;
};

const ModalSellerPoint = (props: Props) => {
  const history = useHistory();
  const progress = (props.sellerPoints / 10) * 100;

  const [sellerInfo, setSellerInfo]: any = useState({});
  const [haveHistory, setHaveHistory] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState('sneakers');
  const [isSellerCreditMinus] = useState(
    parseInt(props.dataAuth?.userdata?.balance_with_fee ?? '0') < 0,
  );
  const [sellingCommissionDetail] = useState(props.sellingCommissionData);
  useEffect(() => {
    setSellerInfo(sellingCommissionDetail[`${selectedCategory}`].find((item) => parseFloat(item.min) <= props.sellerPoints));
  }, [selectedCategory]);

  useEffect(() => {
    if (Array.isArray(props.dataPenjualan) && props.dataPenjualan?.length > 0) {
      setHaveHistory(true);
    }
    setSellerInfo(
      sellingCommissionDetail.sneakers.find((item) => item.min <= props.sellerPoints),
    );
  }, []);

  return (
    <Modal
      className="kick-modal seller-point seller-commision-wrapper"
      show={props.isOpen}
      onHide={props.onToggle}
      centered
    >
      <div id="seller-commision-content">
        <KickImage
          style={{ cursor: 'pointer' }}
          onClick={props.onToggle}
          className="close-btn"
          src={RoundCloseButton}
          alt="close-btn"
        />
        <div
          className="seller-info-header"
          style={{
            backgroundColor: isSellerCreditMinus
              ? '#e02020'
              : sellerInfo.color,
          }}
        >
          <div className="img-container">
            <KickImage src={`${SELLING_COMMISSION_IMAGE}/${sellerInfo.image}`} alt="seller-icon" />
          </div>
          <p className="points">{props.sellerPoints} Points</p>
          <p className="progress-bar-title">Seller Point</p>
          <div className="progress-bar-wrapper">
            <ProgressBar
              completed={progress}
              bgColor={'#fff'}
              height={'4px'}
              isLabelVisible={false}
            />
          </div>
          {isSellerCreditMinus ? (
            <p className="description">
              You have a negative seller credit’s balance,
              <span
                onClick={() => history.push('/helps/general-faq')}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                {' '}
                please take a look
              </span>
            </p>
          ) : (
            <p className="description">
              {sellerInfo && sellerInfo.description}
            </p>
          )}
        </div>

        <div className="seller-info-content">
          <div className="top-section point-calculation">
            <p className="title">Points Calculation:</p>
            {PointsCalculation.map((item, index) => (
              <div className="point-section">
                <div className="left-content">
                  <KickImage className="icon" src={item.icon} alt={'image-seller'} />
                  <div className="mid-text">
                    <p>{item.description}</p>
                    {item.reason && (
                      <>
                        <KickImage
                          data-for="main"
                          data-tip={
                            "<div style='max-width: 250px;'>" +
                            "<p style='color: #fff'><span style='font-family: Nunito-Bold;'><b>" +
                            item.description +
                            '</b></span>, due to:</p>' +
                            "<p style='color: #fff; font-style: normal;'>" +
                            item.reason +
                            '</p>' +
                            '</div>'
                          }
                          data-html={true}
                          data-iscapture="true"
                          src={
                            isSellerCreditMinus
                              ? GREY_INFO_BUTTON
                              : GREEN_INFO_BUTTON
                          }
                          className={`btn-info`}
                        />
                        <ReactTooltip
                          id="main"
                          place={'bottom'}
                          type={'dark'}
                          effect={'solid'}
                          multiline={true}
                          html={true}
                        />
                      </>
                    )}
                  </div>
                </div>

                <p
                  className="right-content"
                  style={{
                    color: item.icon === GREEN_CHECK ? '#159953' : '#e02020',
                  }}
                >
                  {item.point}
                </p>
              </div>
            ))}
          </div>
          <div className="top-section fee-container">
            <p className="title">Sales Commission</p>
            <div className="category-wrapper">
              <div
                onClick={() => setSelectedCategory('sneakers')}
                className={`category ${
                  selectedCategory === 'sneakers' ? 'selected' : ''
                }`}
              >
                <p>Sneakers</p>
              </div>
              <div
                onClick={() => setSelectedCategory('apparel')}
                className={`category ${
                  selectedCategory === 'apparel' ? 'selected' : ''
                }`}
              >
                <p>Apparel</p>
              </div>
              <div
                onClick={() => setSelectedCategory('luxury')}
                className={`category ${
                  selectedCategory === 'luxury' ? 'selected' : ''
                }`}
              >
                <p>Luxury</p>
              </div>
              <div
                onClick={() => setSelectedCategory('electronics-collectibles')}
                className={`category ${
                  selectedCategory === 'electronics-collectibles'
                    ? 'selected'
                    : ''
                }`}
              >
                <p>Electronics & Collectibles</p>
              </div>
            </div>
            <div className="point-title-wrapper">
              <p>Seller Point</p>
              <p>Commission</p>
            </div>
            {sellingCommissionDetail[`${selectedCategory}`].map((item, index) => (
              <div
                className={`point-section ${index === 0 ? 'first-child' : ''} ${
                  !isSellerCreditMinus &&
                  !haveHistory &&
                  item.status === '7 - 7.9'
                    ? 'default-user'
                    : ''
                }`}
              >
                <div className="left-content">
                  <KickImage className="icon" src={`${SELLING_COMMISSION_IMAGE}/${sellerInfo.icon}`} alt={'image-seller'} />
                  <div className="mid-text">
                    <p>{item.status}</p>
                    {!isSellerCreditMinus &&
                    !haveHistory &&
                    item.status === '7 - 7.9' ? (
                      <p className="txt-info-default">
                        Every new user starts here
                      </p>
                    ) : null}
                  </div>
                </div>

                <p className="right-content">{item.detail}</p>
              </div>
            ))}
          </div>
          <div className="info-wrapper fee-info">
            <div className="info-icon">
              <KickImage src={InfoYellow} alt="back-btn" />
            </div>
            <p>
              A penalty fee of IDR 50.000 or 1.5% on sales above IDR 5.000.000
              will be charged on your seller credit’s balance should you fail to
              confirm or complete your sales.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  dataAuth: state.dataAuth,
  dataPenjualan: state?.dataHistory?.history?.dataPenjualan,
});

export default connect(mapStateToProps, null)(ModalSellerPoint);
